<tablesready-party-type-badge
  *ngIf="showTypeBadge"
  [type]="party?.type"
  [confirmed]="party?.confirmed_time"
></tablesready-party-type-badge>

<tablesready-party-source-badge
  *ngIf="party?.source !== partySources.manager"
  [source]="party.source"
></tablesready-party-source-badge>
